// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)
import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import ExampleController from "./example_controller"
application.register("example", ExampleController)

import GeoSortController from "./geo_sort_controller"
application.register("geo-sort", GeoSortController)

import MapsController from "./maps_controller"
application.register("maps", MapsController)

import PayCalculatorController from "./pay_calculator_controller"
application.register("pay-calculator", PayCalculatorController)

import StationsController from "./stations_controller"
application.register("stations", StationsController)

import SuggestionController from "./suggestion_controller"
application.register("suggestion", SuggestionController)
